import { render, staticRenderFns } from "./edit-company.vue?vue&type=template&id=56d536da&"
import script from "./edit-company.vue?vue&type=script&lang=ts&"
export * from "./edit-company.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports